<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M17.63 9a1.14 1.14 0 0 1 1.12 1.35 6.91 6.91 0 0 1-13.48 0A1.13 1.13 0 0 1 6.4 9h11.23Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m19.5 23.25-3.27-8.92M4.5 23.25l3.27-8.92M18.4 20.25H5.6M6.92.75l-.62.82a1.59 1.59 0 0 0 .24 2.18 1.6 1.6 0 0 1 .08 2.39M12.56.75l-.62.82a1.59 1.59 0 0 0 .24 2.18 1.62 1.62 0 0 1 .08 2.39M17.81.75l-.62.82a1.59 1.59 0 0 0 .24 2.18 1.62 1.62 0 0 1 .08 2.39"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
